import { IOsaModel } from 'src/app/models/osa-model';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter, OnDestroy } from "@angular/core";
import { OsaService } from 'src/app/services/osa.service';
import { SharedService } from "../../../../services/shared.service";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-osa-abas',
  templateUrl: './osa-abas.component.html',
  styleUrls: ['./osa-abas.component.scss']
})
export class OsaAbasComponent implements OnInit, OnChanges, OnDestroy {
  public aba = 0;
  @Input() public visualizar: boolean;
  @Input() public numeroOpa: any;
  @Input() public planejamentoId: number = null;
  @Output() public abaEmitter: EventEmitter<number> = new EventEmitter<number>();
  @Input() public id: number;
  @Input() obterDados: () => void;
  public model: IOsaModel = {} as IOsaModel;

  private validacaoSubscription: Subscription;

  constructor(
    public router: Router,
    private osaService: OsaService,
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    // Lógica existente mantida
  }

  ngOnInit(): void {
    const numeroAba = this.activatedRoute.snapshot.queryParamMap.get('aba');
    if (numeroAba) {
      this.mudarAba(Number(numeroAba));
    }
    this.router.url.includes("aba=6") ? this.mudarAba(6) : null;
    this.obter();

    this.validacaoSubscription = this.sharedService.getValidacaoRequest().subscribe(() => {
      this.solicitarValidacaoAbaAtiva();
    });
  }

  ngOnDestroy(): void {
    if (this.validacaoSubscription) {
      this.validacaoSubscription.unsubscribe();
    }
  }

  public obter() {
    this.osaService.obterPorId(this.id).then((res) => {
      this.model = res.dados;
    });
    this.obterDados();
  }

  public mudarAba(ind: number) {
    this.aba = ind;
    this.abaEmitter.emit(this.aba);
  }

  private solicitarValidacaoAbaAtiva() {

    switch (this.aba) {
      case 0:
        break;

      case 1:
        // Aba de Documentos ou outra aba
        this.validarAbaDocumentos();
        break;

      case 2:
        // Aba de Anexos
        this.validarAbaAnexos();
        break;

      case 3:
        // Aba de Observações
        this.validarAbaObservacoes();
        break;

      case 4:
        // Aba de Auditoria
        this.validarAbaAuditoria();
        break;

      case 5:
        // Aba de Relatório
        this.validarAbaRelatorio();
        break;

      case 6:
        // Aba de Aprovação
        this.validarAbaAprovacao();
        break;

      default:
        this.sharedService.sendValidacaoResponse(true);
        break;
    }
  }


  private validarAbaDocumentos() {
    this.sharedService.sendValidacaoResponse(true);
  }

  private validarAbaAnexos() {

    this.sharedService.sendValidacaoResponse(true);
  }

  private validarAbaObservacoes() {

    this.sharedService.sendValidacaoResponse(true);
  }

  private validarAbaAuditoria() {
    this.sharedService.sendValidacaoResponse(true);
  }

  private validarAbaRelatorio() {
    this.sharedService.sendValidacaoResponse(true);
  }

  private validarAbaAprovacao() {
    this.sharedService.sendValidacaoResponse(true);
  }
}
